module.exports = __webpack_public_path__ + "static/media/VirtusEntella.05e863ad.png";